/**
 * Cadastros → Logo: a logo da Aliança aparece no topo do sistema, na tela de
 * entrada e nas imagens dos gráficos baixadas para o WhatsApp.
 * Sem logo, aparece o nome "aliança".
 *
 * Lê: os cadastros (endereço da logo). Grava: api.salvarImagem e api.removerImagem ("logo").
 * Usado por: telas/Cadastros.tsx.
 */
import { useState } from 'react';
import { EscolherImagem } from '../../componentes/EscolherImagem.tsx';
import { api } from '../../dados/api.ts';
import type { Executar } from './comum.ts';

export function Logo({ logo, executar }: { logo: string | null; executar: Executar }) {
  const [trocando, setTrocando] = useState(false);
  return (
    <section className="cartao pilha">
      <div>
        <h2>Logo</h2>
        <p className="subtitulo">Aparece no topo do sistema, na tela de entrada e nas imagens dos gráficos para o WhatsApp. PNG com fundo transparente fica melhor.</p>
      </div>
      <div className="linha-foto">
        {logo ? <img className="logo-imagem logo-previa" src={logo} alt="Logo atual" /> : <span className="texto-apagado">Sem logo: aparece o nome "aliança".</span>}
        {trocando ? (
          <EscolherImagem
            forma="logo"
            aoSalvar={async (imagem) => {
              const certo = await executar(() => api.salvarImagem('logo', imagem), 'Logo salva.');
              if (certo) setTrocando(false);
              return certo;
            }}
            aoCancelar={() => setTrocando(false)}
          />
        ) : (
          <div className="linha-campos">
            <button type="button" className="botao-secundario" onClick={() => setTrocando(true)}>
              {logo ? 'Trocar logo' : 'Pôr logo'}
            </button>
            {logo ? (
              <button
                type="button"
                className="botao-link"
                onClick={() => {
                  if (window.confirm('Remover a logo? Volta a aparecer o nome "aliança".')) void executar(() => api.removerImagem('logo'), 'Logo removida.');
                }}
              >
                remover logo
              </button>
            ) : null}
          </div>
        )}
      </div>
    </section>
  );
}
